import React, { memo, useCallback, useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Icon from "../assets/icons/Icon";
import { useSelector } from "react-redux";
import { allRoutes, userReportRoutes } from "../Static/data";

const Sidebar = () => {
  const [activeSections, setActiveSections] = useState({});
  const [isFixed, setIsFixed] = useState(false); // 👈 Track fixed state
  const location = useLocation();
  const { user } = useSelector((state) => state.user);

  const toggleSection = useCallback((section) => {
    setActiveSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  }, []);

  useEffect(() => {
    setActiveSections({});
  }, [location.pathname]);

  // 👇 Handle scroll to toggle fixed sidebar
  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = 80;
      if (window.scrollY > scrollThreshold) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const role = user?.role?.toLowerCase();
  const allowed = new Set(
    user?.pages?.split(",").map((p) => p.trim().toLowerCase()) || []
  );

  const isRouteAllowed = (route) => {
    const path = route.to.replace(/^\//, "").toLowerCase();
    if (path === "loginhistory") return true;
    return allowed.has(path);
  };

  const filteredAllRoutes =
    role === "admin" ? allRoutes : allRoutes.filter(isRouteAllowed);

  const filteredUserReportRoutes =
    role === "admin"
      ? userReportRoutes
      : userReportRoutes
          .filter(({ label }) => !(role === "user" && label === "Manage User"))
          .filter(isRouteAllowed);

  return (
    <>
      <aside className={`sidebar-cover ${isFixed ? "sidebar_fixed" : ""}`}>
        <ul className="firstUl">
          <li className="dropdown_box">
            <NavLink
              className={({ isActive }) =>
                `sidebar_menu_font menu_card ${isActive ? "active" : ""}`
              }
              to="/dashboard"
            >
              <Icon name="MdDashboard" className="icon_sid" />
              <span className="sidebar_name">Dashboard</span>
            </NavLink>
          </li>

          {filteredAllRoutes.map(({ to, icon, label }) => (
            <li key={to} className="dropdown_box">
              <NavLink
                className={({ isActive }) =>
                  `sidebar_menu_font menu_card ${isActive ? "active" : ""}`
                }
                to={to}
              >
                <Icon name={icon} className="icon_sid" />
                <span className="sidebar_name">{label}</span>
              </NavLink>
            </li>
          ))}

          <li
            className={`dropdown_box ${activeSections.Accounts ? "open" : ""}`}
          >
            <Link
              className={`sidebar_menu_font menu_card ${
                activeSections.Accounts ? "menu_card" : ""
              }`}
              onClick={() => toggleSection("Accounts")}
            >
              <Icon name="FaSuitcase" className="icon_sid" />
              <span className="sidebar_name">User Reports</span>
              <Icon name="FaAngleDown" className="down_icon" />
            </Link>
            <ul
              className={`top_menu_open ${
                activeSections.Accounts ? "" : "d-none"
              }`}
            >
              {filteredUserReportRoutes.map(({ label, to, icon }) => (
                <li key={label}>
                  <Link className="sidebar_open-box" to={to}>
                    <Icon name={icon} className="icon_sid" />
                    <span className="sidebar_name">{label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </aside>
      <div className="stratas-overlay d-print-none"></div>
    </>
  );
};

export default memo(Sidebar);
